var map = {
	"./a1.png": "Q7ml",
	"./a1en.png": "/PNL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2MR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet ^\.\/a1.*\.png$
// module id = g2MR
// module chunks = 0